import React, { Component } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import Select from 'react-select';
import Modal from 'react-modal';
import TextFieldGroup from '../../inputs/TextFieldGroup';
import { addFilter } from '../../actions/apiFilters';
import { toggleAddFilter } from '../../actions/toggleMenu';

class AddFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
      filter_choice: '',
      filter_name: '',
      filter_operator: '',
      filter_value: '',
      filter_target: '',
      data_origin: '',
      filter_type: '',
      name: '',
      errors: { addFilterError: false },
    };
    this.onChange = this.onChange.bind(this);
    this.onChangeData = this.onChangeData.bind(this);
    this.onChangeType = this.onChangeType.bind(this);
    this.onChangeDataOrigin = this.onChangeDataOrigin.bind(this);
    this.onChangeOperator = this.onChangeOperator.bind(this);
    this.onChangeSelectAllFilters = this.onChangeSelectAllFilters.bind(this);
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.addFilter = this.addFilter.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  onChangeData(e) {
    this.setState({ filter_target: e.value });
  }

  onChangeType(e) {
    this.setState({ filter_type: e.value });
  }

  onChangeDataOrigin(e) {
    this.setState({ data_origin: e.value, filter_target: '' }); // Reset filter_target when data_origin changes
  }

  onChangeOperator(e) {
    this.setState({ filter_operator: e.value });
  }

  onChangeSelectAllFilters(e) {
    if (e.value === 'Create New Filter') {
      this.props.toggleAddFilter(true);
    } else {
      this.props.toggleAddFilter(false);
    }
    this.setState({ filter_choice: e.value });
  }

  onClick(e) {}

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  afterOpenModal() {}

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  vehicle_columns() {
    const newObj = Object.keys(this.props.vehicle_columns).map(
      (key) => this.props.vehicle_columns[key]
    );
    return _.sortBy(newObj, 'name');
  }

  selectColumns() {
    const columns = this.vehicle_columns();
    const options = columns.map((option) => ({
      value: option.id,
      label: option.name,
    }));
    return options;
  }

  allFilters() {
    const options = this.props.all_filters.map((option) => ({
      value: option.id,
      label: `${option.filter_name} ( ${option.filter_target} ${option.filter_operator} ${option.filter_value} )`,
    }));
    options.push({ value: 'Create New Filter', label: 'Create New Filter' });
    return options;
  }

  selectData() {
	if (this.state.data_origin === 'mpi_work_items') {
		const mpiColumns = [
		'vehicle_id', 'work_item_preset_id', 'name', 'description', 'category', 'estimate_type', 'estimate_total',
		'order', 'show_mpi', 'active', 'deleted', 'dealership', 'auto_assign', 'auto_assign_trigger',
		'auto_assign_department_id', 'auto_assign_user_id', 'default_status', 'assign_to_source',
		'profile_dropdown_users', 'automove_counter', 'automove_pending', 'automove_getapproved',
		'automove_approved', 'automove_waiting', 'automove_denied', 'automove_trigger_value',
		'feed_default', 'ro_email_link_approved', 'ro_email_link_declined',
		'ro_email_link_counter_approved', 'ro_email_link_counter_declined', 'ro_status',
		'ro_number', 'ro_files', 'classification', 'assigned', 'recipients', 'recipients_by_uid',
		'recipients_by_date', 'label_requested', 'requested_by_uid', 'requested_date',
		'label_recipients', 'label_pass', 'pass', 'pass_by_uid', 'pass_by_date', 'label_recommend',
		'recommend', 'recommend_by_uid', 'recommend_by_date', 'label_required', 'required',
		'required_by_uid', 'required_by_date', 'label_labor_rate', 'labor_rate', 'labor_rate_by_uid',
		'labor_rate_by_date', 'label_labor_hours', 'labor_hours', 'labor_hours_by_uid',
		'labor_hours_by_date', 'label_labor_total', 'labor_total', 'labor_total_by_uid',
		'labor_total_by_date', 'label_parts', 'parts', 'parts_by_uid', 'parts_by_date',
		'label_parts_total', 'parts_total', 'parts_total_by_uid', 'parts_total_by_date',
		'label_quantity', 'quantity', 'quantity_by_uid', 'quantity_by_date', 'label_estimate_total',
		'estimate_total_by_uid', 'total_by_date', 'label_approved', 'approved', 'approved_by_uid',
		'approved_by_date', 'label_declined', 'declined', 'declined_by_uid', 'declined_by_date',
		'declined_reason', 'label_completed', 'completed_by_uid', 'completed_by_date', 'completed',
		'label_counter', 'counter_by_uid', 'counter_by_date', 'counter', 'lock_pass', 'lock_recommend',
		'lock_required', 'lock_labor_rate', 'lock_labor_hours', 'lock_labor_total', 'lock_parts',
		'lock_parts_total', 'lock_quantity', 'lock_estimate_total', 'lock_approved', 'lock_declined',
		'lock_completed', 'lock_estimate', 'lock_counter', 'dvi_pdf_show', 'dvi_pdf_comments',
		'left_front', 'right_front', 'left_rear', 'right_rear', 'front_actual', 'front_min', 'rear_actual', 'rear_min',
		'left_front_by_uid', 'right_front_by_uid', 'left_rear_by_uid', 'right_rear_by_uid',
		'front_actual_by_uid', 'front_min_by_uid', 'rear_actual_by_uid', 'rear_min_by_uid',
		'left_front_by_date', 'right_front_by_date', 'left_rear_by_date', 'right_rear_by_date',
		'front_actual_by_date', 'front_min_by_date', 'rear_actual_by_date', 'rear_min_by_date',
		'layout_type', 'dvi_description', 'form', 'section', 'custom_header_1', 'custom_header_2',
		'custom_header_3', 'custom_header_4', 'custom_header_5', 'custom_header_6'
		].sort(); // Sort alphabetically
		return mpiColumns.map((col) => ({ value: col, label: col }));
	}
	return this.props.vehicle_columns.map((option) => ({
		value: option.name || option,
		label: option.name || option,
	}));
	}

  selectComparison() {
    const comparisonArray = [
      { name: 'Greater Than', label: 'Greater Than' },
      { name: 'Greater or Equal', label: 'Greater or Equal' },
      { name: 'Equals', label: 'Equals' },
      { name: 'Not Equals', label: 'Not Equals' },
      { name: 'Less Than', label: 'Less Than' },
      { name: 'Less or Equal', label: 'Less or Equal' },
      { name: 'Contains', label: 'Contains' },
    ];
    return comparisonArray.map((option) => ({
      value: option.name,
      label: option.label,
    }));
  }

  selectDataType() {
    const comparisonArray = [
      { name: 'number', label: 'Number' },
      { name: 'condition', label: 'Condition' },
    ];
    return comparisonArray.map((option) => ({
      value: option.name,
      label: option.label,
    }));
  }

  selectDataOrigin() {
    const comparisonArray = [
      { name: 'vehicle', label: 'Vehicle' },
      { name: 'vehicle_meta', label: 'Vehicle Meta' },
      { name: 'mpi_work_items', label: 'MPI Work Items' },
    ];
    return comparisonArray.map((option) => ({
      value: option.name,
      label: option.label,
    }));
  }

  deleteDepartment(e) {
    this.props.deleteDepartment(e.target.dataset.id);
  }

  addFilter() {
    const { department } = this.props;
    const errorType = 'add filter';
    const data = {
      filter_name: this.state.filter_name,
      filter_operator: this.state.filter_operator,
      filter_value: this.state.filter_value,
      filter_target: this.state.filter_target,
      filter_type: this.state.filter_type,
      data_origin: this.state.data_origin,
      active: true,
    };
    this.props.addFilter(data, errorType);
  }

  render() {
    const { department } = this.props;
    const { errors } = this.state;
    const body = (
      <div className="container">
        <div className="list-group">
          <div className="list-group-item">
            <TextFieldGroup
              field="filter_name"
              label="Filter Name"
              onChange={this.onChange}
              value={this.state.filter_name}
              type="text"
              key={'add_filter_name'}
              error={errors.addFilterError}
            />
          </div>
          <div className="list-group-item">
            <label>Data Origin</label>
            <Select
              onChange={this.onChangeDataOrigin}
              value={this.selectDataOrigin().filter(
                ({ value }) => value === this.state.data_origin
              )}
              name={'data_origin'}
              options={this.selectDataOrigin()}
              className="text-capitalize bigdropdown"
              clearable={false}
              searchable
              key={'add_data_origin'}
              placeholder="Choose Data Origin"
              error={errors.addFilterError}
            />
          </div>
          <div className="list-group-item">
            <label>Data Type</label>
            <Select
              onChange={this.onChangeType}
              value={this.selectDataType().filter(
                ({ value }) => value === this.state.filter_type
              )}
              name={'filter_type'}
              options={this.selectDataType()}
              className="text-capitalize bigdropdown"
              clearable={false}
              searchable
              key={'add_filter_type'}
              placeholder="Choose Filter Type"
              error={errors.addFilterError}
            />
          </div>
          <div className="list-group-item">
            <label>Data</label>
            <Select
              onChange={this.onChangeData}
              value={this.selectData().filter(
                ({ value }) => value === this.state.filter_target
              )}
              name={'filter_target'}
              options={this.selectData()}
              className="text-capitalize bigdropdown"
              clearable={false}
              searchable
              key={'add_filter_target'}
              placeholder="Choose Input Type"
              error={errors.addFilterError}
            />
          </div>
          <div className="list-group-item">
            <label>Operator</label>
            <Select
              onChange={this.onChangeOperator}
              value={this.selectComparison().filter(
                ({ value }) => value === this.state.filter_operator
              )}
              name={'filter_operator'}
              options={this.selectComparison()}
              className="text-capitalize bigdropdown"
              clearable={false}
              searchable
              key={'add_filter_operator'}
              placeholder="Choose Operator"
              error={errors.addFilterError}
            />
          </div>
          <div className="list-group-item">
            <TextFieldGroup
              field="filter_value"
              name="filter_value"
              label="Value"
              onChange={this.onChange}
              value={this.state.filter_value}
              type="text"
              key={'add_filter_value'}
              error={errors.addFilterError}
            />
          </div>
        </div>
      </div>
    );

    return (
      <span>
        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          className="d-flex justify-content-center"
          contentLabel="Add Condition/Filter"
          ariaHideApp={false}
          overlayClassName="overlay"
        >
          <div className="card space-top-1 w-75">
            <div className="card-header bg-dark text-white">
              Add/Create new Condition{' '}
              <button
                className="btn btn-sm btn-danger float-end"
                onClick={this.closeModal}
              >
                x
              </button>
            </div>
            <div className="card-block bg-white">
              <hr />
              {body}
            </div>
            <div className="card-footer">
              <button
                className="btn btn-sm btn-success float-start"
                onClick={this.addFilter}
              >
                <i className="fa fa-plus" /> Add
              </button>
            </div>
          </div>
        </Modal>
        <button
          className="btn btn-sm btn-primary float-end"
          onClick={this.openModal}
        >
          <i className="fa fa-plus" /> Create/Add Condition
        </button>
      </span>
    );
  }
}

const mappedActions = {
  toggleAddFilter,
  addFilter,
};

function mapStateToProps(state) {
  return {
    departments: state.settings_departments.departments,
    all_filters: state.settings_site.all_filters,
    vehicle_columns: state.settings_departments.vehicle_columns,
    edit_department: state.settings_admin.edit_department,
    show_add_filter: state.settings_nav.show_add_filter,
  };
}
export default connect(mapStateToProps, mappedActions)(AddFilter);